import createCrud from './crud';

export default createCrud({
    resource: 'project-reports'
});